<template>
  <BaseInnerSidebar :show-title="false">
    <template #title>
      <div class="flex items-center gap-2">
        <i class="pi pi-cog text-primary-600" />
        <span>Contracts</span>
      </div>
    </template>
    <template #content>
      <nav class="space-y-1">
        <nuxt-link
          v-for="(tab, index) in visibleTabs"
          :key="index"
          :to="tab.route"
          class="block"
        >
          <BaseSidebarOption :is-active="tab.active">
            <Icon
              :name="tab.icon"
              class="text-base w-4"
            />
            <span>{{ tab.name }}</span>
          </BaseSidebarOption>
        </nuxt-link>
      </nav>
    </template>
  </BaseInnerSidebar>
</template>

<script lang="ts" setup>
import { ContractIcons } from '~/types/baseIcon'

const route = useRoute()
const { can } = useRolePermissions()
const config = useRuntimeConfig()
const country = String(config.public.country || 'UNITED_STATES')

const routeName = computed(() => route.name as string)

const tabs = computed(() => [
  {
    name: 'Contract Details',
    icon: ContractIcons.DETAILS,
    route: { name: 'contracts-id-details' },
    active: routeName.value === 'contracts-id-details',
    capability: Capabilities.CONTRACTS.DETAILS,
  },
  {
    name: 'Activity',
    icon: ContractIcons.ACTIVITY,
    route: { name: 'contracts-id-activity' },
    active: routeName.value === 'contracts-id-activity',
    capability: Capabilities.CONTRACTS.ACTIVITY,
  },
  {
    name: 'Files',
    icon: ContractIcons.FILES,
    route: { name: 'contracts-id-files' },
    active: routeName.value === 'contracts-id-files',
    capability: Capabilities.CONTRACTS.FILES,
  },
  {
    name: 'Transactions',
    icon: ContractIcons.TRANSACTIONS,
    route: { name: 'contracts-id-transactions' },
    active: routeName.value === 'contracts-id-transactions',
    capability: Capabilities.CONTRACTS.TRANSACTIONS,
    hidden: country !== 'AUSTRALIA',
  },
])

const visibleTabs = computed(() => tabs.value.filter(tab => !tab.hidden && can(tab.capability)))
</script>
